import { ExternalLink, RefreshCw } from 'lucide-react';
import type { Hash } from 'viem';

interface TransactionAttempt {
  error: unknown;
  hash?: Hash;
  retry: () => unknown;
}

function isTimeoutError(error: unknown) {
  if (!error) return false;
  const value = error as { name?: string; message?: string; shortMessage?: string };
  const text = `${value.name ?? ''} ${value.shortMessage ?? ''} ${value.message ?? ''}`.toLowerCase();
  return text.includes('timeout') || text.includes('timed out');
}

export default function TransactionTimeout({ attempts }: { attempts: TransactionAttempt[] }) {
  const attempt = attempts.find((item) => item.hash && isTimeoutError(item.error));
  if (!attempt?.hash) return null;

  return (
    <div className="rounded-lg border border-amber-400/30 bg-amber-400/10 px-3 py-2 text-xs text-amber-300">
      <p>트랜잭션이 오래 걸립니다. BSCScan에서 직접 확인해 주세요.</p>
      <div className="mt-2 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => attempt.retry()}
          className="inline-flex items-center gap-1 rounded-md bg-amber-400 px-2 py-1 font-semibold text-abyss-950 hover:bg-amber-300"
        >
          <RefreshCw size={12} /> 재시도
        </button>
        <a
          href={`https://testnet.bscscan.com/tx/${attempt.hash}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 rounded-md border border-amber-400/30 px-2 py-1 font-medium hover:bg-amber-400/10"
        >
          BSCScan에서 확인 <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
